import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

const InjectMassage = (props) => <FormattedMessage {...props} />;

export const IntlMessage = injectIntl(InjectMassage, { withRef: false });

export default IntlMessage;
